import { getTransportRegistry } from "../transport-shortcut-registration";
// todo: put transport shortcut directly on RpcOpts. Eg: `new WranggleRpc({ electron: myElectronOpts })`
//   I don't feel like a typescript research project at the moment.. need to check if each transport could declare the same module or whatever and add it own option
export function buildTransport(val) {
    if (typeof val === 'string') {
        val = { transportType: val };
    }
    if (!val || typeof val !== 'object') {
        throw new Error('Invalid transport options');
    }
    if (typeof val.transport === 'string') { // perhaps do similar for "val.type"
        val.transportType = val.transport;
        delete val.transport;
    }
    let transport;
    if (_isTransport(val)) {
        transport = val;
    }
    else {
        let transportType, transportOpts;
        if (_hasTransportType(val.transportType || val.type)) {
            transportType = val.transportType || val.type;
            transportOpts = val;
        }
        if (transportOpts === true) {
            transportOpts = {};
        }
        if (transportType) {
            transport = getTransportRegistry()[transportType](transportOpts);
        }
    }
    if (!transport) {
        throw new Error('Unable to creat transport instance from passed in options');
    }
    return transport;
}
export function extractTransportOpts(rpcOpts) {
    if (rpcOpts.transport) {
        return rpcOpts.transport;
    }
    const transportType = Object.keys(rpcOpts).find(transportType => _hasTransportType(transportType));
    let transportOpts = transportType && rpcOpts[transportType];
    if (!transportOpts || typeof transportOpts !== 'object') {
        transportOpts = {};
    }
    transportOpts.transportType = transportType;
    return transportOpts;
}
function _hasTransportType(transportType) {
    return !!(transportType && getTransportRegistry()[transportType]);
}
function _isTransport(val) {
    if (typeof val !== 'object') {
        return false;
    }
    return val && ['sendMessage', 'listen', 'stopTransport'].every(m => typeof val[m] === 'function');
}
//# sourceMappingURL=transport-construction.js.map